var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isPC } from '@/util/help';
import Context from '@/context/createContext';
import intl from 'react-intl-universal';
import { getBaseInfo, updateInvoice } from '@/api';
import { Types } from '../util/typeConfig';
import { mobileRoutes } from './systemRoutes';
import { Modal } from 'antd-mobile';
import _ from 'lodash';
import Mobile from './mobile';
import PC from './pc';
import './index.less';
var types = Object.keys(Types).join('|');
var Routers = function (_a) {
    var headerTitle = _a.headerTitle, setHeaderTitle = _a.setHeaderTitle;
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState({}), errorInfo = _c[0], setErrorInfo = _c[1];
    var _d = useState(false), visibleHeader = _d[0], setVisibleHeader = _d[1];
    var _e = useState(true), visibleFooter = _e[0], setVisibleFooter = _e[1];
    var _f = useState(''), code = _f[0], setCode = _f[1]; // code标识来查询客户信息
    var _g = useState('signature'), type = _g[0], setType = _g[1]; // type标识表示追签或追账
    var _h = useState({}), patientInfo = _h[0], setPatientInfo = _h[1]; // 存储用户信息
    var _j = useState([]), invoiceInfo = _j[0], setInvoiceInfo = _j[1]; // 账单列表
    var _k = useState([]), pdfList = _k[0], setPdfList = _k[1]; // pdf列表
    var _l = useState('/'), currentPath = _l[0], setCurrentPath = _l[1]; // 当前路由：用于footer高亮
    var _m = useState(false), landscapeAlert = _m[0], setLandscapeAlert = _m[1];
    var location = useLocation();
    var getWindowSize = function () {
        var userAgentObj = JSON.parse(localStorage.getItem('userAgentObj')) || null;
        if (userAgentObj && (userAgentObj.isIOS || userAgentObj.isAndroid)) {
            return {
                innerHeight: document.body.scrollHeight,
                innerWidth: document.body.scrollWidth,
            };
        }
        else {
            return {
                innerHeight: window.innerHeight,
                innerWidth: window.innerWidth,
            };
        }
    };
    useEffect(function () {
        localStorage.removeItem('changeInvoice');
        sessionStorage.removeItem('patientInfo');
        sessionStorage.removeItem('invoiceInfo');
        setPatientInfo({});
        setInvoiceInfo([]);
    }, []);
    useEffect(function () {
        // 监听
        window.addEventListener('resize', handleResize);
        // 销毁
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [getWindowSize()]);
    // 刷新当前页面
    var handleResize = function () {
        var orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
        orientation === 'landscape' ? setLandscapeAlert(true) : setLandscapeAlert(false);
    };
    // 更新上次支付信息
    var updateInvoiceInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updateRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateInvoice({ merTradeNo: localStorage.getItem('payId') })];
                case 1:
                    updateRef = _a.sent();
                    if (updateRef && updateRef.status) {
                        localStorage.removeItem('payId');
                        sessionStorage.clear();
                        window.location.reload();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // 根据code获取账单数据
    var fnInit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var param, code, type, params, targetRouterConfig, res, _patientInfo, _resInvoiceInfo, _invoiceList, changeInvoice_1, rowIds_1, _invoiceInfo, newList_1, addList_1, _newList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    param = new URLSearchParams(location.search);
                    code = param.get('code');
                    type = param.get('type');
                    params = {};
                    if (code) {
                        params = Object.assign({}, params, { code: code });
                    }
                    if (type) {
                        params = Object.assign({}, params, { type: type });
                    }
                    setType(type);
                    setCode(code);
                    targetRouterConfig = mobileRoutes.some(function (item) { return item.path === location.pathname; });
                    if (!(Object.values(params).length < 2)) return [3 /*break*/, 1];
                    /**
                     * 参数校验:无code&&type 或 type非追签/追账
                     */
                    setVisibleHeader(false);
                    setVisibleFooter(false);
                    setError(true);
                    setErrorInfo({
                        type: 'checkError',
                        title: '',
                        description: '',
                    });
                    return [2 /*return*/];
                case 1:
                    if (!!targetRouterConfig) return [3 /*break*/, 2];
                    /**
                     * 路由守卫校验
                     */
                    setVisibleFooter(false);
                    setError(true);
                    setErrorInfo({
                        type: '404',
                        title: '',
                        description: '',
                    });
                    return [2 /*return*/];
                case 2:
                    if (!(Object.keys(Types).indexOf(type) === -1)) return [3 /*break*/, 3];
                    setVisibleFooter(false);
                    setError(true);
                    setErrorInfo({
                        type: 'codeError',
                        title: '',
                        description: '链接无效',
                    });
                    return [2 /*return*/];
                case 3:
                    if (!(location.pathname === '/' || location.pathname === '/main')) return [3 /*break*/, 5];
                    if (localStorage.getItem('payId') && type === 'payment') {
                        sessionStorage.clear();
                        updateInvoiceInfo();
                    }
                    return [4 /*yield*/, getInfo(params)];
                case 4:
                    res = _a.sent();
                    if (!res || (res && !res.status)) {
                        /**
                         * code查询失败
                         */
                        setVisibleFooter(false);
                        setError(true);
                        setErrorInfo({
                            type: 'codeError',
                            title: '',
                            description: (res && res['message']) || '链接失效',
                        });
                        return [2 /*return*/];
                    }
                    if (res && (!res.data || Object.keys(res.data).length === 0)) {
                        /**
                         * 无数据
                         */
                        setVisibleFooter(false);
                        setError(true);
                        setErrorInfo({
                            type: 'codeError',
                            title: '',
                            description: (res && res['message']) || '暂无信息',
                        });
                        return [2 /*return*/];
                    }
                    _patientInfo = res.data['patientInfo'] || {};
                    _resInvoiceInfo = res.data['invoiceInfo'] || [];
                    _invoiceList = [];
                    if (localStorage.getItem('changeInvoice')) {
                        changeInvoice_1 = JSON.parse(decodeURIComponent(localStorage.getItem('changeInvoice')));
                        rowIds_1 = _.map(changeInvoice_1, 'invoiceRowId');
                        _invoiceList = _resInvoiceInfo.map(function (item) {
                            if (rowIds_1.indexOf(item.invoiceRowId) !== -1) {
                                var changeInvoiceItem = changeInvoice_1.filter(function (changeItem) { return changeItem && changeItem.invoiceRowId === item.invoiceRowId; });
                                item.paymentAmount = changeInvoiceItem[0].paymentAmount;
                            }
                            return item;
                        });
                    }
                    else {
                        _invoiceList = JSON.parse(JSON.stringify(_resInvoiceInfo));
                    }
                    _invoiceInfo = _invoiceList.map(function (billItem) {
                        if (Object.keys(billItem).indexOf('nameCn') === -1 || billItem['nameCn'] === 'null') {
                            billItem['nameCn'] = null;
                        }
                        if (Object.keys(billItem).indexOf('nameEn') === -1 || billItem['nameEn'] === 'null') {
                            billItem['nameEn'] = null;
                        }
                        if (Object.keys(billItem).indexOf('paymentAmount') === -1) {
                            billItem['paymentAmount'] = billItem.outstandingAmount || 0;
                        }
                        return billItem;
                    });
                    _invoiceList = _.sortBy(_invoiceInfo, function (item) {
                        return item.invoiceNumber;
                    });
                    setPatientInfo(_patientInfo);
                    sessionStorage.setItem('patientInfo', encodeURIComponent(JSON.stringify(res.data.patientInfo)));
                    setInvoiceInfo(JSON.parse(JSON.stringify(_invoiceInfo)));
                    sessionStorage.setItem('invoiceInfo', encodeURIComponent(JSON.stringify(_invoiceInfo)));
                    // 追签的pdf
                    if (type === 'signature') {
                        newList_1 = [];
                        addList_1 = [];
                        // 根据账单list生成pdf的list
                        JSON.parse(JSON.stringify(_invoiceInfo)).forEach(function (billItem, index) {
                            billItem = Object.assign(billItem, { pdf: '' }, { pdfType: 'Invoice' });
                            if (billItem.claimPdf) {
                                var obj = JSON.parse(JSON.stringify(billItem));
                                obj.pdfType = 'Claim';
                                delete obj.invoicePdf;
                                delete obj.invoiceSigningStatus;
                                addList_1.push(obj);
                            }
                            delete billItem.claimPdf;
                            delete billItem.claimSigningStatus;
                            newList_1.push(billItem);
                        });
                        //组成pdf的数据：将账单和保单的pdf合并
                        newList_1 = newList_1.concat(addList_1);
                        // 排序：根据invoiceNumber\invoiceDate组成pdf的list
                        newList_1 = _.sortBy(_.sortBy(newList_1, function (item) {
                            return item.invoiceNumber;
                        }));
                        _newList = JSON.parse(JSON.stringify(newList_1));
                        setPdfList(__spreadArray([], _newList, true));
                        sessionStorage.setItem('pdfList', encodeURIComponent(JSON.stringify(_newList)));
                    }
                    _a.label = 5;
                case 5:
                    setCurrentPath(location.pathname);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fnInit();
    }, [location.pathname, localStorage.getItem('payId')]);
    function getInfo(data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseInfo(data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    return (_jsx(Context.Provider, __assign({ value: { patientInfo: patientInfo, invoiceInfo: invoiceInfo, pdfList: pdfList, type: type } }, { children: isPC ? (_jsx(PC, { error: error, errorInfo: errorInfo })) : (_jsx(_Fragment, { children: landscapeAlert ? (Modal.alert({
                content: intl.get('landscapeContent'),
                confirmText: intl.get('landscapeConfirmText'),
                onConfirm: function () {
                    window.location.reload();
                },
            })) : (_jsx(Mobile, { currentPath: currentPath, setCurrentPath: setCurrentPath, error: error, errorInfo: errorInfo, setVisibleHeader: setVisibleHeader, headerTitle: headerTitle, setHeaderTitle: setHeaderTitle })) })) })));
};
export default Routers;
